import { OvertimeWorkedAndScheduledPerPeriodModel } from "../models/OvertimeSchedule";
import { normalizeDateString } from "./date.utils";

const getWeekAtIndex = (
  employee: OvertimeWorkedAndScheduledPerPeriodModel,
  selectedWeekIndex: number,
) => employee.periods?.[selectedWeekIndex];

const sumOvertimeByDate = (
  data: OvertimeWorkedAndScheduledPerPeriodModel[],
  selectedWeekIndex: number,
  dateKey: string,
  type: "scheduled" | "worked",
) => {
  const total = data.reduce((acc, employee) => {
    const week = getWeekAtIndex(employee, selectedWeekIndex);

    if (!week?.days?.length) {
      return acc;
    }

    const day = week.days.find(
      (currentDay) => normalizeDateString(currentDay.date) === dateKey,
    );

    if (!day) {
      return acc;
    }

    return (
      acc + (type === "scheduled" ? day.scheduledOvertime : day.workedOvertime)
    );
  }, 0);

  return total;
};

export const getTotalScheduledOvertimeByDate = (
  data: OvertimeWorkedAndScheduledPerPeriodModel[],
  selectedWeekIndex: number,
  dateKey: string,
) => sumOvertimeByDate(data, selectedWeekIndex, dateKey, "scheduled");

export const getTotalWorkedOvertimeByDate = (
  data: OvertimeWorkedAndScheduledPerPeriodModel[],
  selectedWeekIndex: number,
  dateKey: string,
) => sumOvertimeByDate(data, selectedWeekIndex, dateKey, "worked");

const sumOvertimeForWeek = (
  data: OvertimeWorkedAndScheduledPerPeriodModel[],
  selectedWeekIndex: number,
  type: "scheduled" | "worked",
) =>
  data.reduce((acc, employee) => {
    const week = getWeekAtIndex(employee, selectedWeekIndex);

    if (!week) {
      return acc;
    }

    return (
      acc +
      (type === "scheduled"
        ? week.totalScheduledOvertime
        : week.totalWorkedOvertime)
    );
  }, 0);

export const getTotalScheduledOvertimeForWeek = (
  data: OvertimeWorkedAndScheduledPerPeriodModel[],
  selectedWeekIndex: number,
) => sumOvertimeForWeek(data, selectedWeekIndex, "scheduled");

export const getTotalWorkedOvertimeForWeek = (
  data: OvertimeWorkedAndScheduledPerPeriodModel[],
  selectedWeekIndex: number,
) => sumOvertimeForWeek(data, selectedWeekIndex, "worked");

export const getTotalOverlapWorkedScheduledForWeek = (
  data: OvertimeWorkedAndScheduledPerPeriodModel[],
  selectedWeekIndex: number,
) =>
  data.reduce((acc, employee) => {
    const week = getWeekAtIndex(employee, selectedWeekIndex);
    if (!week) return acc;
    return acc + week.totalOverlapWorkedScheduled;
  }, 0);

export const getTotalDifferenceForWeek = (
  data: OvertimeWorkedAndScheduledPerPeriodModel[],
  selectedWeekIndex: number,
) =>
  getTotalScheduledOvertimeForWeek(data, selectedWeekIndex) -
  getTotalWorkedOvertimeForWeek(data, selectedWeekIndex);
